import React from 'react';
var Youtube = function Youtube(_ref) {
  var codigo = _ref.codigo;
  return React.createElement("iframe", {
    width: "560",
    height: "315",
    src: "https://www.youtube.com/embed/" + codigo,
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: true
  });
};
export default Youtube;